export const namespace = 'rfq'
